import { storefrontClient } from './storeFrontClient';

interface CartItem {
  variantId: string;
  quantity: number;
}

interface CheckoutResponse {
  checkoutUrl: string;
  checkoutId: string;
}

export async function createShopifyCheckout(items: CartItem[]): Promise<CheckoutResponse> {
  const lines = items.map((item) => ({
    merchandiseId: item.variantId,
    quantity: item.quantity,
  }));

  const mutation = `
    mutation cartCreate($input: CartInput!) {
      cartCreate(input: $input) {
        cart {
          id
          checkoutUrl
        }
        userErrors {
          field
          message
        }
      }
    }
  `;

  const variables = {
    input: {
      lines,
    },
  };

  try {
    const response = await storefrontClient.post('', {
      query: mutation,
      variables,
    });

    if (response.data.errors) {
      console.error('[Shopify] GraphQL errors:', response.data.errors);
      throw new Error('Failed to create cart: ' + JSON.stringify(response.data.errors));
    }

    const { cart, userErrors } = response.data.data.cartCreate;

    if (userErrors && userErrors.length > 0) {
      console.error('[Shopify] Cart user errors:', userErrors);
      throw new Error(userErrors[0].message);
    }

    if (!cart || !cart.checkoutUrl) {
      console.error('[Shopify] No checkout URL in response:', { cart });
      throw new Error('No checkout URL returned from Shopify');
    }

    return {
      checkoutUrl: cart.checkoutUrl,
      checkoutId: cart.id,
    };
  } catch (error) {
    console.error('[Shopify] Error creating cart:', {
      error,
      message: error instanceof Error ? error.message : 'Unknown error',
      response:
        error && typeof error === 'object' && 'response' in error ? error.response : undefined,
    });
    throw error;
  }
}
